import React from 'react';
import './App.css';
import ImageWithFallback from "./ImageWithFallback";

const Factorial = () => {
  return (
    <div className="page-container">
      <div className="hero-section">
        <h1>Factorial</h1>
        <p>Calculate the factorial of a number with this Python project.</p>
        <ImageWithFallback src="/Factorial.png" alt="Factorial" className="hero-image" />
      </div>
      <div className="content-section">
        <h2>Project Description</h2>
        <p>This project calculates the factorial of a number using Python code.</p>
        <h2>Download</h2>
        <a href="/Factorial.py" download>Download Factorial.py</a>
        <h2>How to Run</h2>
        <p>Run the Python file and input a number to calculate its factorial.</p>
      </div>
      <footer style={{
        backgroundColor: "#f8f9fa",
        padding: "20px 0",
        textAlign: "center",
        borderTop: "1px solid #e9ecef",
      }}>
        <div>
          <h4>Coding Projects</h4>
          <select style={{ padding: "10px", borderRadius: "5px" }}>
            <option value="games">Games</option>
            <option value="math">Math</option>
            <option value="drawing">Drawing</option>
          </select>
        </div>
        <div style={{ marginTop: "10px" }}>
          <a href="/terms-and-conditions">Terms & Conditions</a>
        </div>
      </footer>
    </div>
  );
};

export default Factorial;
